import { SoundToggleComponent } from "appworks/components/sound/sound-toggle-component";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";

export class AgsSoundToggleComponent extends SoundToggleComponent {
    /**
     * the super function will force unmute, overriding the saved setting
     * for some reason this doesn't affect epic ui games but it does affect ags games, so override this function in ags
     */
    protected loadComplete() {
        this.loadingSprite?.setVisible(false);
        Services.get(SoundService).onLoadComplete.remove(this.loadCompleteHandler);
    }
}